var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"scrollToMe",attrs:{"id":"app"}},[(_vm.isUserLoggedIn)?_c('TopBar'):_vm._e(),_c('div',{staticClass:"columns"},[(_vm.isUserLoggedIn)?_c('SideBar',{staticClass:"column is-one-quarter has-text-left mt-5"}):_vm._e(),_c('MainBar',{staticClass:"column"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }